import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import Notifications from '@/components/v2/Notifications';
import NotificationMarkAsRead from '@/plugins/graphql/mutations/v2/notification-mark-as-read.gql';
import UnreadNotificationsCount from '@/components/v2/UnreadNotificationsCount';
import UnreadNotifications from '@/plugins/graphql/queries/v2/unread-notifications-count.gql';
import { NAV_DRAWER } from '@/helpers/constants/app';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppStatus from '@/plugins/graphql/queries/v3/app-status.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { NotificationCategory } from '@/helpers/entities/enums/v2/NotificationCategory';
const opts = { namespace: NAV_DRAWER };
let NotificationList = class NotificationList extends Mixins(ViewportSizeMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.appStatus = null;
    }
    get notificationIcon() {
        return require('@/assets/images/notification_icon.svg');
    }
    onToggle(val) {
        if (!val) {
            this.hideNotifications();
        }
    }
    /**
     * Redirect Merchant to Order History and Filter Records using
     * transaction Number
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @param [String] transaction number
     *
     * @return { void }
     */
    redirectToOrderHistory(transactionNumber) {
        let routeName = 'order-history';
        if (this.$route.params.key === 'mall-stores-management-bundle') {
            routeName = 'store-management-orders';
        }
        this.$router.push({
            name: routeName,
            query: {
                txn: transactionNumber,
            },
        });
    }
    /**
     * Redirect Merchant to Billing Details Page
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @param [String] uuid billing uuid
     *
     * @since Version {0.6.0}
     *
     * @return { void }
     */
    redirectToBillingPage(uuid) {
        this.$router.push({ name: 'billing-details', params: { uuid } });
    }
    async onRead(notif) {
        await this.markAsRead(notif.uuid).then(() => {
            if (notif.notifForOrder) {
                this.redirectToOrderHistory(notif.transactionNumber);
            }
            else if (notif.category === NotificationCategory.NegativeSentimentReminder) {
                this.goToInboxManager();
            }
        });
    }
    async markAsRead(notificationUuid) {
        const vm = this;
        return this.$apollo.mutate({
            mutation: NotificationMarkAsRead,
            variables: {
                input: {
                    notificationUuid,
                },
            },
            refetchQueries: [
                {
                    query: UnreadNotifications,
                    variables: {
                        appUuid: vm.appUuid,
                    },
                },
            ],
        });
    }
    /**
     * Scroll Event Handler
     * Check if User scroll at the bottom of the page for infinite scrolling
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.10.0}
     *
     * @return {void}
     */
    onScroll(e) {
        const element = e.target;
        const scrollingTreshold = element.scrollHeight - element.offsetHeight;
        const scrolledToLowerMostOfPage = scrollingTreshold === element.scrollTop;
        if (scrolledToLowerMostOfPage) {
            const { notifications } = this.$refs;
            notifications.fetchMore();
        }
    }
    get drawerWidth() {
        if (this.smOnly) {
            return '450';
        }
        return '637';
    }
    /*
     * Fix issue: v-navigation-drawer is not always full height
     * Reference: https://github.com/vuetifyjs/vuetify/issues/4384#issuecomment-620617356
     */
    get drawerHeight() {
        if (this.xsOnly) {
            return 'calc(100% - 62px)';
        }
        return 'calc(100% - 72px)';
    }
    async fetchAppStatus() {
        await this.$apollo
            .query({
            query: AppStatus,
            variables: {
                appUuid: this.$store.state.appUUID,
            },
        })
            .then((result) => {
            this.appStatus = result?.data?.app;
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    async goToInboxManager() {
        await this.fetchAppStatus();
        const status = this.getAppStatus(this.appStatus);
        if (status === 'Active') {
            this.$router.push({
                name: 'inbox-manager',
                params: { uuid: this.$store.state.appUUID, to: 'inbox-manager' },
            });
            this.showInbox(true);
            this.$store.commit('setSelectedFilter', 'negative_sentiment');
            return;
        }
        this.errorNotification(`Your app is ${status.toLowerCase()}. ${this.statusMessage(status)}`);
    }
    statusMessage(status) {
        switch (status) {
            case 'Under Maintenance':
                return 'Please disable the maintenance mode to use this feature.';
            case 'Unlaunched':
                return 'Please launch your app to use this feature.';
            default:
                return 'Please contact the ChatGenie support team.';
        }
    }
    getAppStatus(app) {
        const { status, maintenance } = app;
        if (status === 'Inactive') {
            return 'Disconnected';
        }
        if (maintenance) {
            return 'Under Maintenance';
        }
        return status;
    }
};
__decorate([
    Prop({ type: String, required: true })
], NotificationList.prototype, "appUuid", void 0);
__decorate([
    Mutation('showInbox', { namespace: NAV_DRAWER })
], NotificationList.prototype, "showInbox", void 0);
__decorate([
    Getter('showNotifications', opts)
], NotificationList.prototype, "showNotifications", void 0);
__decorate([
    Mutation('hideNotifications', opts)
], NotificationList.prototype, "hideNotifications", void 0);
NotificationList = __decorate([
    Component({
        components: {
            Notifications,
            UnreadNotificationsCount,
        },
    })
], NotificationList);
export default NotificationList;
